import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Lesson, LessonStatus } from './lesson.model';
import { LessonPopupService } from './lesson-popup.service';
import { LessonService } from './lesson.service';
import { CRUD_ACTIONS } from '../../shared/index';

@Component({
    selector: 'jhi-lesson-confirm-cancel-dialog',
    templateUrl: './lesson-confirm-cancel-dialog.component.html'
})
export class LessonConfirmCancelDialogComponent {

    lesson: Lesson;
    sendNotifications: boolean;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private lessonService: LessonService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['lesson', 'lessonStatus', 'reservation', 'reservationStatus', 'student', 'classType']);
        this.sendNotifications = true;
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmCancel(id: number) {
        let copy: Lesson = Object.assign({}, this.lesson);

        copy.status = LessonStatus.CANCELLED;
        this.lessonService.cancel(copy, this.sendNotifications).subscribe(result => {
            this.eventManager.broadcast({
                name: 'lessonCancelled', content: {
                    action: CRUD_ACTIONS.UPDATE,
                    content: result
                }
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-lesson-confirm-cancel-popup',
    template: ''
})
export class LessonConfirmCancelPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private lessonPopupService: LessonPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.lessonPopupService
                .open(LessonConfirmCancelDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson-confirm-cancel-dialog.component.ts